// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1Zimm","author":"Table_author__19Cq4","authorImage":"Table_authorImage__18qlM","unreadRow":"Table_unreadRow__1c9uR"};